import { useRouter } from "next/router";
import { call } from "goi_common";
import { useParlorInquiryModal as useSharedParlorInquiryModal } from "goi_common/src/design-system";

/**
 * platform 용 장례식장 문의 모달.
 *
 * 조문 문의만 장례식장 직통으로 가고 나머지 셋은 고이 1666-9784 다.
 * 발신은 call() 로 통일해 새벽 2~7시 차단, PC alert, goi_call 집계를 그대로 받는다.
 * 빈소 예약 및 고인 이송 문의(urgent)만 새벽 차단을 건너뛴다.
 *
 * 번호는 장례식장 목록(2.4MB)에서 찾아야 해서 전 페이지 번들에 싣지 않도록
 * 클릭 시점에 동적으로 불러온다. 클릭은 하이드레이션 이후라 router.query.id 가 채워져 있다.
 * 불러오기가 실패해도 모달은 열리고, 조문 문의는 고이로 폴백한다.
 *
 * @param eventPath 모달 안 5개 이벤트를 쏠 화면 path
 */
export const useParlorInquiryModal = (
  eventPath: "parlor_detail" | "parlor_estimates" | "parlor_match_request" | "urgent_bnr",
) => {
  const router = useRouter();
  const { openInquiryModal } = useSharedParlorInquiryModal({
    eventPath,
    onDial: (phoneNumber, isUrgent) => call(phoneNumber, isUrgent),
  });

  const openParlorInquiryModal = async () => {
    let facilityPhone: string | null = null;

    try {
      const { getParlorPhoneByRouteId } = await import("@/utils/parlorPhone");
      facilityPhone = getParlorPhoneByRouteId(router.query.id);
    } catch {
      facilityPhone = null;
    }

    openInquiryModal(facilityPhone);
  };

  return { openParlorInquiryModal };
};
